<!-- Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised" class="ms-container mat-elevation-z1">
  <mat-card-content>
    <div *ngIf="showADLogin; else waiting;">
        <div class="login-wrapper">
          <h1>{{'SIGN_IN_WITH_MICROSOFT' | translate}}</h1>
        </div>
        <form novalidate>
            <div class="ms-form-wrapper">
              <div class="login-error" *ngIf="loginError">
                <span tabindex="1" class="error-message">{{'LI_INVALID' | translate}}</span>
              </div>
              <mat-grid-list cols="1" rows="2" rowHeight="70px">
                <mat-grid-tile>
                  <div>
                      <mat-error *ngIf="hasError('notAuthorized')">
                          {{'ERROR_NOT_AUTH_DOMAIN' | translate}}
                      </mat-error>
                      <mat-error *ngIf="hasError('cigentAccountExists')">
                          {{'ERROR_CIGENT_ACCOUNT_EXISTS' | translate}}
                      </mat-error>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile>
                  <div>
                      <img [src]="(theme | async) === 'dark' ? msButtonDarkPath : msButtonLightPath"
                           appThrottleClick throttleTime="1000" (throttleClick)="onMSClick()"
                           alt="Sign in with Microsoft button" />
                  </div>
                </mat-grid-tile>
                <mat-grid-tile>
                  <h2>or</h2>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
        </form>
        <div class="back-to-cigent">
          <button mat-flat-button (click)="toggleSigIn()">{{'CIGENT_SIGN_IN' | translate}}</button>
        </div>
    </div>
    <ng-template #waiting>
        <div class="signing-in">
            <span class="empty-value">{{'NOTIFICATION_SIGNING_IN' | translate}}</span>
            <mat-progress-spinner
                class="spinner"
                color="primary"
                mode="indeterminate"
                diameter="25">
            </mat-progress-spinner>
        </div>
    </ng-template>
  </mat-card-content>
</mat-card>
